export const APPLICATION_NAME = 'YGIIOPS';
export const APPLICATION_NAME_NORMAL = 'Ygii - OPS Portal';
export const APP_VERSION = '2.0.0';

export const LOCAL_STORAGE_ACCESS_TOKEN = `${APPLICATION_NAME}_ACCESS_TOKEN`;
export const LOCAL_STORAGE_REFRESH_TOKEN = `${APPLICATION_NAME}_REFRESH_TOKEN`;

export const LOCAL_STORAGE_PHONE_COUNTRY = `${APPLICATION_NAME}_PHONE_COUNTRY`;
export const LOCAL_STORAGE_SELECTED_LOCALE = `${APPLICATION_NAME}_SELECTED_LOCALE`;
export const SESSION_STORAGE_SELECTED_LOCALE = `${APPLICATION_NAME}_SELECTED_LOCALE`;

export const googlePlacesKey = 'AIzaSyCR388mWBleCqk4xOU2ZBjoBM_Aiu6VNt4';

export const SPLASH_SCREEN_DURATION_IN_MILLIS = 400;

export const keyboardTypeEnum = {
  default: 'default',
  email: 'email-address',
  numeric: 'number-pad',
  decimal: 'decimal-pad',
  phone: 'phone-pad',
};

export const currencies = [
  { value: 'sar', text: 'SAR', symbol: 'SR' },
  { value: 'usd', text: 'USD', symbol: '$' },
  { value: 'eur', text: 'EUR', symbol: '€' },
  { value: 'kwd', text: 'KWD', symbol: 'ك' },
  { value: 'bhd', text: 'BHD', symbol: 'BD' },
  { value: 'aed', text: 'AED', symbol: 'د.إ' },
  { value: 'qar', text: 'QAR', symbol: '﷼' },
  { value: 'omr', text: 'OMR', symbol: '﷼' },
  { value: 'egp', text: 'EGP', symbol: '£' },
  { value: 'jod', text: 'JOD', symbol: 'Dinar' },
  { value: 'gbp', text: 'GBP', symbol: '£' },
  { value: 'cny', text: 'CNY', symbol: '¥' },
  { value: 'rub', text: 'RUB', symbol: '₽' },
  { value: 'aud', text: 'AUD', symbol: '$' },
  { value: 'inr', text: 'INR', symbol: '₹' },
];

export const getCurrencySymbol = currencyValue => {
  switch (currencyValue) {
    case currencies[0].value:
      return currencies[0].symbol;
    case currencies[1].value:
      return currencies[1].symbol;
    case currencies[2].value:
      return currencies[2].symbol;
    case currencies[3].value:
      return currencies[3].symbol;
    case currencies[4].value:
      return currencies[4].symbol;
    case currencies[5].value:
      return currencies[5].symbol;
    case currencies[6].value:
      return currencies[6].symbol;
    case currencies[7].value:
      return currencies[7].symbol;
    case currencies[8].value:
      return currencies[8].symbol;
    case currencies[9].value:
      return currencies[9].symbol;
    case currencies[10].value:
      return currencies[10].symbol;
    case currencies[11].value:
      return currencies[11].symbol;
    case currencies[12].value:
      return currencies[12].symbol;
    case currencies[13].value:
      return currencies[13].symbol;
    case currencies[14].value:
      return currencies[14].symbol;
    default:
      return 'N/A';
  }
};

export const DEFAULT_LATITUDE = 24.774265;
export const DEFAULT_LONGITUDE = 46.738586;
export const MAP_ZOOM_LEVEL = 11;
export const MAP_LIBRARIES = ['places'];

export const ONLINE_LOCATION_NAME = 'Online';

export const PARTNER_FRONT_URL = 'https://partners.ygii.app';
// export const PARTNER_FRONT_URL = 'http://localhost:3001';
export const PARTNER_FRONT_URL_STAGING = 'https://staging-partners.ygii.app';

export const BUSINESS_FRONT_URL = 'https://portal.ygii.app';
// export const BUSINESS_FRONT_URL = 'http://localhost:3000';
export const BUSINESS_FRONT_URL_STAGING = 'https://stagingbusiness-portal.ygii.app';

export const partnerOrderState = {
  created: 'created',
  accepted: 'accepted',
  readyForPickup: 'readyForPickup',
  delivered: 'delivered',
};

export const DELIVERY_TYPE = {
  PARTNER_ORDER: 'partnerOrder',
  PICK_UP: 'pick-up',
  DROP_OFF: 'drop-off',
};

export const DELIVERY_STATE = {
  PENDING: 'pending',
  PICKED_UP: 'pickedUp',
  PICKING_UP: 'pickingUp',
  DELIVERED: 'delivered',
  DELIVERING: 'delivering',
};
